import { useCallback } from "react";
import { handleErrors } from "./handleErrors";
import {
  addInHistory,
  setInContextHelper,
  setJackpotInfo,
  setJackpotWin,
  setFullRoundResponce,
  setAirdrop,
  placeBetResponce,
  jackpotIsActive,
  setValueHelper,
} from "./helpers/setInContextHelper";
import { logger } from "../helpers/logger";

export const useReceiveMessages = ({
  setContext,
  handleNotification,
  handleErrorText,
  setErrorCode,
  setRoundValue,
}: any) => {
  const receiveMessage = useCallback((msg: any) => {
    if (msg === null) return logger.log("receiveMessage msg === null ", msg);
    else if (msg.code) {
      if (msg.code === 114) {
        jackpotIsActive(setContext);
      } else {
        console.error("%cERROR ", "color:aqua", msg);
        handleErrors(msg.code, handleErrorText, handleNotification);
        setErrorCode(msg.code);
      }
    } else {
      switch (msg.service) {
        case "history":
          return addInHistory(msg.data, setContext);
        case "jackpot":
          return setJackpotInfo(msg.data, setContext);
        case "playjackpot":
          return setJackpotWin(msg.data, setContext);
        case "fullround":
          return setFullRoundResponce(msg.data, setContext);
        case "airdrop":
          return setAirdrop(msg.data, setContext);
        case "placebet":
          if (
            msg.data.error &&
            msg.data.error.code &&
            msg.data.error.code !== 112
          ) {
            const code = msg.data.error.code;
            handleErrors(code, handleErrorText, handleNotification);
            setErrorCode(code);
          }
          return placeBetResponce(msg.data, setContext);
        case "auth":
        case "settings":
        case "config":
        case "bet":
        case "ping":
        case "train":
        case "userupdate":
          setInContextHelper(msg, setContext);
          break;
        case "roundupdate":
          // if (msg.data.state !== 2) {
          //   setInContextHelper(msg, setContext);
          // } else {
          setValueHelper(msg, setRoundValue);
          // setInContextHelper(msg, setContext);
          // console.log(msg.data.state, "state");
          // }
          break;
        case "disconnect":
          logger.log("%cDISCONNECT", "color:aqua", msg);
          handleErrors("", handleErrorText, handleNotification);
          break;
        case "cashout":
          logger.log(msg);
          break;
        default:
          console.error(
            "receiveMessage switch default case",
            msg // ErrorTypes[msgObject.errorCode],
          );
          break;
      }
    }
  }, []);

  return receiveMessage;
};
